var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"split-container"},[(_vm.showLeftContainer)?_c('div',{staticClass:"split-container-child left-container",class:{
      rightContentShow: _vm.showRightContainer == true,
    }},[_vm._t("leftContent")],2):_vm._e(),(_vm.showRightContainer)?_c('div',{staticClass:"split-container-child right-container"},[_vm._t("rightContent")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }